<template>
    <div class="content_main">
        <div class="content_main_top">
            <a-select placeholder="所属流程" show-search :filter-option="filterOption" allowClear
                class="a_input_self margin_self" v-model="queryParam.procDefKey" @keyup.enter.native="search">
                <a-select-option :value="item.id" v-for="(item, index) in approvalList" :key="index">
                    {{ item.name }}
                </a-select-option>
            </a-select>
            <a-select allowClear placeholder="请选择所属公司" class="a_input_self margin_self" v-model="queryParam.companyId"
                @change="getDepartList" @keyup.enter.native="search">
                <a-select-option :value="item.value" v-for="(item, index) in companyList" :key="index">
                    {{ item.title }}
                </a-select-option>
            </a-select>
            <a-tree-select @keyup.enter.native="search" allowClear :treeData="departList" placeholder="请选择部门"
                v-model="queryParam.deptId" class="a_input_self margin_self" :disabled="!queryParam.companyId">
            </a-tree-select>
            <a-input placeholder="请输入审批编号" allowClear class="a_input_self margin_self" v-model="queryParam.applyCode"
                @keyup.enter.native="search" />
            <a-input placeholder="请输入审批标题" allowClear class="a_input_self margin_self" v-model="queryParam.title"
                @keyup.enter.native="search" />
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="reset">重置</a-button>
        </div>
        <div class="content_main_center_scroll">
            <div class="bodyTop" ref="bodyTop" id="content_main_center_scroll">
                <a-table :data-source="data" :scroll="{ y: tableScrollY }" :pagination="false" rowKey="id"
                    @change="handleChange">
                    <a-table-column title="序号" key="index" dataIndex="index" width="100px">
                        <template slot-scope="text, record, index">
                            {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                        </template>
                    </a-table-column>
                    <a-table-column title="申请编号" key="applyCode" dataIndex="applyCode" width="260px"></a-table-column>
                    <a-table-column title="申请标题" key="title" dataIndex="title" width="200px"></a-table-column>
                    <a-table-column title="所属流程" key="procName" dataIndex="procName"></a-table-column>
                    <a-table-column title="申请人" key="applyer" dataIndex="applyer" width="100px"></a-table-column>
                    <a-table-column title="申请时间" key="applyTime" dataIndex="applyTime" sorter=" true"></a-table-column>
                    <a-table-column title="最后审批人" key="lastAuditor" dataIndex="lastAuditor"></a-table-column>
                    <a-table-column title="最后审批时间" key="lastAuditorTime" dataIndex="lastAuditorTime"></a-table-column>
                    <a-table-column key="result" ellipsis="true" title="审批结果" data-index="result">
                        <template scope="text">
                            <span class="tag_class" :style="{ background: result_apply[text].color }">
                                {{ result_apply[text].txt }}
                            </span>
                        </template>
                    </a-table-column>
                    <!-- <a-table-column title="审批结果" key="result" dataIndex="result"></a-table-column> -->
                    <a-table-column title="操作" key="id" dataIndex="id">
                        <template slot-scope="text, record">
                            <a @click="detail(record)">详情</a>
                            <a-divider type="vertical" />
                            <a @click="historyRecord(record)">历史</a>

                            <!-- <a-button type="link" @click="changeInfo(record)"> 编辑 </a-button> -->
                        </template>
                    </a-table-column>
                </a-table>
                <div class="pageBottom">
                    <a-pagination v-model="pagination.current" show-size-changer :page-size.sync="pagination.pageSize"
                        :total="pagination.totalCount" @showSizeChange="onShowSizeChange"
                        :pageSizeOptions="['10', '20', '30', '40', '50']" @change="onShowSizeChange" />
                </div>
            </div>
            <!-- <div class="bodyBottom"> -->
            <leave-modal ref="leavemodal" @ok="handleOk" :audit="audit" />
            <purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" />
            <proc-flow-modal ref="modal" @ok="handleOk" />
            <scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
            <receive-modal ref="receiveModal" @ok="handleOk" :audit="audit" />
            <operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
            <service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
            <reimbursement-modal ref="reimbursementmodal" @ok="handleOk" :audit="false" />
            <payMentModal ref="paymentmodal" @ok="handleOk" :audit="false" />
            <contractModal ref="contractmodal" @ok="handleOk" :audit="false" />
            <sealModal ref="sealmodal" :audit="false" />
            <currencyModal ref="currencymodal" :audit="false" />
            <returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
            <car-modal ref="carmodal" @ok="handleOk" :audit="false" />
            <returncar-modal ref="returncarmodal" @ok="handleOk" :audit="false" />
            <salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
            <adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
            <charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
            <other-modal ref="othermodal" @ok="handleOk" :audit="false" />
            <feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
            <inventory-modal ref="inventorymodal" @ok="handleOk" :audit="false" />
            <newPaymentModel ref="newPaymentModel"></newPaymentModel>
            <salaryEditModal ref="salaryEditModal" :audit="false"></salaryEditModal>
            <quotation ref="quotation" :audit="false"></quotation>
            <contractReview ref="contractReview" :audit="false"></contractReview>
            <tender ref="tender" :audit="false"></tender>
	  	    <contractDetail ref="contractDetail"  :audit="false"></contractDetail>
            <terminationModal ref="terminationModal"  :audit="false"></terminationModal>


            <!-- </div> -->

        </div>
    </div>

</template>

<script>
import terminationModal from '@/views/activiti/modules/terminationModal.vue'
import salaryEditModal from './modules/salaryEditModal.vue'
import newPaymentModel from './modules/newPaymentModel.vue'
import { audit_list } from '@/api/financial'
import { tree_all, getReassignment } from '@/api/purchase'
import { modalMap } from '@/api/activiti'
import LeaveModal from './modules/LeaveModal.vue'
import PurchaseModal from './modules/PurchaseModal.vue'
import ProcFlowModal from './modules/ProcFlowModal.vue'
import receiveModal from './modules/receiveModal.vue' //领用
import ScrapModal from './modules/ScrapModal.vue' //报废
import OperationModal from './modules/OperationModal.vue'
import ServiceModal from './modules/ServiceModal.vue'
import ReimbursementModal from './modules/ReimbursementModal.vue'
import payMentModal from '@/views/activiti/modules/payMentModal.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal from '@/views/activiti/modules/returncarModal.vue'
import salaryModal from '@/views/activiti/modules/salaryModal.vue'
import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
import chargeModal from '@/views/activiti/modules/chargeModal.vue'
import otherModal from '@/views/activiti/modules/otherModal.vue'
import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
import InventoryModal from '@/views/activiti/modules/InventoryModal.vue'
import quotation from './modules/quotation.vue'
import contractReview from '@/views/activiti/modules/contractReview.vue'
import tender from '@/views/activiti/modules/tender.vue'
import contractDetail from '@/views/projectCollection/contract/contractDetail.vue'
export default {
    components: {
        contractDetail,
        tender,
        contractReview,
        quotation,
        salaryEditModal,
        LeaveModal,
        ProcFlowModal,
        PurchaseModal,
        receiveModal,
        ScrapModal,
        OperationModal,
        ServiceModal,
        ReimbursementModal,
        payMentModal,
        contractModal,
        sealModal,
        currencyModal,
        returnModal,
        carModal,
        returncarModal,
        salaryModal,
        adjustmentModal,
        chargeModal,
        otherModal,
        feedbackModal,
        InventoryModal,
        newPaymentModel,
        terminationModal
    },
    data() {
        return {

            queryParam: {
                procDefKey: undefined,
                companyId: undefined,
                deptId: undefined,
                sortField: '',
                sortOrder: ''


            },
            //所属流程数组
            approvalList: [],
            //公司
            companyList: [],
            //部门
            departList: [],
            tableScrollY: 150,
            //分页数据
            pagination: { //分页数据
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                current: 1,
                pageSize: 10,
                totalCount: 0
            },
            //表格绑定数据
            data: [],

        }
    },
    created() {
        this.getData()
        this.getCompany()
        this.getApprovalList()

        // this.$nextTick((res) => {
        //      this.tableScrollY = this.$refs.bodyTop.offsetHeight - 60
        //  })

    },
    mounted() {
        this.$nextTick(() => {
            var max_h = $('#content_main_center_scroll').height()
            console.log(max_h, 'max_hmax_hmax_hmax_hmax_hmax_hmax_h')
            // setTimeout(() => {
            this.tableScrollY = max_h - $('.ant-table-header').height() - 35
            console.log(this.tableScrollY ,'this.tableScrollY this.tableScrollY this.tableScrollY this.tableScrollY ')
        })
    },
    methods: {
        handleOk() {
            this.$refs.table.refresh(true)
            console.log('handleSaveOk')
        },
        //详情
        detail(record) {
            Object.assign(record, {
                businessKey: record.id,
                recordNumber: 1

            })
            var fdStart = record.procDefKey.indexOf("payment-")
            if (fdStart == 0) {
                this.$refs.newPaymentModel.init(record)
            } else {
                const modal = modalMap[record.procDefKey]
                this.$refs[modal].show(record)
            }
        },

        //历史
        historyRecord(row) {
            var obj = {
                procInstId: row.procInstId,
                procDefKey: row.procDefKey,
            }
            this.$refs.modal.show(obj)
        },
        //获取当前列表数据
        getData() {
            getReassignment({
                procDefKey: this.queryParam.procDefKey,
                companyId: this.queryParam.companyId,
                deptId: this.queryParam.deptId,
                pageSize: this.pagination.pageSize,
                pageIndex: this.pagination.current,
                sortField: this.queryParam.sortField,
                sortOrder: this.queryParam.sortOrder
            }).then(res => {
                if (res.code == 200) {
                    this.data = res.data.list
                    this.pagination.totalCount = res.data.totalCount
                    console.log(res.data, 'res.data====================')
                }

            })


        },
        //获取公司
        getCompany() {
            tree_all().then(res => {
                if (res.code == 200) {
                    this.companyList = res.data[0]
                }
            })
        },
        //获取部门
        getDepartList(e) {
            this.queryParam.deptId = undefined
            this.departList = []
            this.companyList.forEach(item => {
                if (item.deptId == e) {
                    this.departList = item.children
                }
            })

        },
        //获取所属流程
        getApprovalList() {
            audit_list().then(res => {
                if (res.code == 200) {
                    this.approvalList = res.data
                }
            })
        },
        //下拉列表查询事件
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        //查询事件
        search() {
            //   this.pagination.pageSize = 1
            this.pagination.current = 1
            this.getData()


        },
        // 重置事件
        reset() {
            this.queryParam.procDefKey = undefined,
                this.queryParam.companyId = undefined,
                this.queryParam.deptId = undefined,
                this.queryParam.applyCode = '',
                this.queryParam.title = ''

            this.pagination.current = 1
            this.getData()

        },
        //表格变化
        handleChange(pagination, filters, sorter) {
            console.log(sorter, 'sorter===============')
            if (sorter.order) {
                this.queryParam.sortField = sorter.field
                this.queryParam.sortOrder = sorter.order.replace('end', '')
            } else {
                this.queryParam.sortField = 'applyTime'
                this.queryParam.sortOrder = 'desc'
            }

            this.getData()

        },
        //分页
        onShowSizeChange(current, pageSize) {
            console.log(current, pageSize);
            this.pagination.current = current
            this.pagination.pageSize = pageSize;
            //改变完 重新渲染数据
            this.getData()

        },
        onSelectChange(selectedRowKeys) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
        },
    }

}
</script>

<style scoped>
.bodyTop {
    width: 100%;
    height: 100%;
    float: left;
}

.pageBottom {
    width: 100%;
    height: 35px;
    float: left;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
}
</style>